import "./Portfolio.module.css";
import Header from "@/reusable_sections/Header";
import OurGlobalPartners from "./sections/OurGlobalPartners";
import Footer from "@/reusable_sections/Footer";
export default function PortfolioPage() {
  return <div>
      <Header />
      <OurGlobalPartners />
      <Footer />
    </div>;
}